/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const AlarmExclamationRegularV6 = (props) => (
  <Icon {...props} name="Alarm Exclamation Regular V6">
    <path d="M0 2.976A2.976 2.976 0 0 1 5 .794L.464 4.575A2.967 2.967 0 0 1 0 2.976zM7 12a1 1 0 1 1 2 0 1 1 0 1 1-2 0zm1.75-2.75c0 .416-.334.75-.75.75s-.75-.334-.75-.75v-3.5c0-.416.334-.75.75-.75s.75.334.75.75v3.5zm3.641 5.203C11.191 15.419 9.663 16 8 16s-3.191-.581-4.391-1.547l-1.329 1.3a.708.708 0 0 1-1.061 0c-.293-.266-.293-.741 0-1.034l1.328-1.328a7 7 0 1 1 10.905 0l1.3 1.328c.319.294.319.769 0 1.034-.266.319-.741.319-1.034 0l-1.328-1.3zM8 3.5a5.5 5.5 0 1 0 .001 11.001A5.5 5.5 0 0 0 8 3.5zM13.025 0a2.975 2.975 0 0 1 2.509 4.575L11 .794C11.503.301 12.244 0 13.025 0z" />
  </Icon>
);

export default AlarmExclamationRegularV6;
